import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

interface ILinkItemProps {
  href: string;
  label: string;
  handle?: string;
  highlighted: boolean;
  color?: string;
}

const LinkItem: React.FC<ILinkItemProps> = ({
  href,
  label,
  handle,
  highlighted,
  color,
}) => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      // force focus into page when a headernav menu item is opened
      document?.getElementById('global-main')?.focus({ preventScroll: true });
    };

    router.events.on('routeChangeComplete', handleRouteChange);
  }, []);

  return (
    <li className="tw-hidden desktop:tw-flex desktop:tw-items-end">
      <Link href={href} legacyBehavior>
        <a data-testid={`linkitem-go-to-${label}`}>
          <span className={`hxrt ${highlighted ? 'highlighted' : ''}`}>
            {label}
          </span>
          {/* underline-parent needed only for highlighted items */}
          <div className={`${highlighted ? 'underline-parent' : ''}`}>
            <div className="underline"></div>
          </div>
        </a>
      </Link>
      <style jsx>{`
        li > a {
          display: block;
          color: ${color ? color : `var(--black)`};
          white-space: nowrap;
          transition: all 0.3s ease;
          text-align: center;
        }

        li > a::first-letter {
          text-transform: capitalize;
        }

        li > a:hover,
        li > a:focus {
          color: var(--clr-tertiary-1);
        }

        .highlighted {
          background-color: var(--clr-primary-3);
          border-radius: 25px;
          padding: var(--space-2) var(--space-3);
        }

        .underline-parent {
          padding: 0 var(--space-3);
          margin-top: -2px;
        }

        .underline {
          visibility: ${handle && router.query.handle === handle
            ? `inherit`
            : `hidden`};
          height: 4px;
          content: '';
          background: var(--clr-tertiary-1);
          width: 100%;
          border-radius: var(--rd-2);
          margin-top: 6px;
        }
      `}</style>
    </li>
  );
};

export default LinkItem;
